module.exports = __webpack_public_path__ + "img/scan.c0b4a0dc.svg";